import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const LINKS = [
  { to: '/deadly-crossing', label: 'Home', match: (path) => path === '/deadly-crossing' || path === '/deadly-crossing/' },
  { to: '/deadly-crossing/privacy', label: 'Privacy Policy', match: (path) => path.startsWith('/deadly-crossing/privacy') },
  { to: '/deadly-crossing/support', label: 'Support', match: (path) => path.startsWith('/deadly-crossing/support') },
];

/**
 * Mutual nav for Deadly Crossing store legal pages (Home / Privacy / Support).
 */
const DeadlyCrossingNav = () => {
  const { pathname } = useLocation();

  return (
    <nav className="flex flex-wrap gap-x-4 gap-y-2 text-sm border-b border-gray-200 pb-4 mb-8" aria-label="Deadly Crossing">
      {LINKS.map(({ to, label, match }) => {
        const active = match(pathname);
        return (
          <Link
            key={to}
            to={to}
            className={
              active
                ? 'font-semibold text-emerald-700'
                : 'text-emerald-600 hover:text-emerald-800 hover:underline'
            }
            aria-current={active ? 'page' : undefined}
          >
            {label}
          </Link>
        );
      })}
    </nav>
  );
};

export default DeadlyCrossingNav;
